
import portfolio1 from '../Asset/img/amazo website.png'
import portfolio2 from '../Asset/img/timezone.png'
import portfolio3 from '../Asset/img/youtube.png'

const project = [
    {
        name: 'Amazone',
        url: '',
        imageUrl: portfolio1,
        text: 'This is a amazon clone web application.This is a e-comerce web site.Its make for practise',
    },
    {
        name: 'YouTube API',
        url: 'https://endearing-lily-ef7c6d.netlify.app',
        imageUrl: portfolio3,
        text: 'This is a youtube api project.If we give a youtube playlistId in the serchbox.then we can see a youtube playlist.',
    },
    {
        name: 'TimeZone Watch',
        url: 'https://joyful-cucurucho-d0860b.netlify.app',
        imageUrl: portfolio2,
        text: 'This is a timezone project.you can see a local clock and set another timezone clock.',
    }
]

export default project